import { gql } from '@apollo/client';

export const CRM_TASK_FIELDS = `
    _id
    title
    description
    accountId
    accountName
    contactId
    contactName
    ownerId
    ownerName
    status
    isRecurring
    seriesId
    recurrencePattern {
        frequency
        interval
        daysOfWeek
        dayOfWeek
        weekOfMonth
        dayOfMonth
        monthOfYear
        endType
        endDate
        endAfterOccurrence
    }
    dueAt
    reminderAt
    reminderSentAt
    source
    completedAt
    createdAt
    updatedAt
`;

export const LIST_CRM_TASKS = gql`
    query ListCrmTasks($input: ListCrmTasksInput) {
        listCrmTasks(input: $input) {
            ${CRM_TASK_FIELDS}
        }
    }
`;
